// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d785f698","239":"60a0e865","453":"03179fbb","553":"237cb841","977":"78fd8c58"}[chunkId] + ".chunk.js";
};